/* tslint:disable:object-literal-sort-keys */
export default {
	// Some Common Messages
	'app.common.dialog-okay-button-text': 'Okay',
	'app.common.dialog-small-okay-button-text': 'Ok',
	'app.common.dialog-cancel-button-text': 'Cancel',
	'app.common.dialog-confirm-button-text': 'Confirm',
	'app.common.dialog-preview-image-text': 'Preview',
	'app.common.export': 'Export',
	'app.common.search': 'Search',
	'app.common.none-value': 'None',
	'app.common-predefined-filters-Custom': 'Custom',
	'app.common-predefined-filters-Last7Days': 'Last 7 Days',
	'app.common-predefined-filters-Last30Days': 'Last 30 Days',
	'app.common-predefined-filters-MonthToDate': 'Month To Date',
	'app.common-predefined-filters-QuarterToDate': 'Quarter To Date',
	'app.common-predefined-filters-YearToDate': 'Year To Date',
	'app.common-predefined-filters-label': 'Predefined Filters',
	'app.common-page-label': 'Page',
	'app.common-leave-blank-to-auto-populate-label': '(Leave blank to auto populate)',
	'app.common-row-count-label': 'Rows {0} - {1} of {2}',
	'app.common.not-applicable-value': 'N/A',
	'app.common.json-label': 'JSON',
	'app.common.enable-confirm-dialog-text': 'Are you sure you want to enable the {name}?',
	'app.common.disable-confirm-dialog-text': 'Are you sure you want to disable the {name}?',
	'app.common.do-you-want-to-continue-text': 'Do you want to continue?',

	// On App Component
	'app.component.carrier': 'Carrier',
	'app.component.carriers': 'Carriers',
	'app.component.account-level-overrides': 'Account Level Overrides',
	'app.component.carrier-accounts': 'Carrier Accounts',
	'app.carrier.carrier-code-label': 'Carrier Code',
	'app.carrier.carrier-account-name-label': 'Carrier Account Name',
	'app.carrier.carrier-provider-label': 'Carrier Provider',
	'app.component.settings': 'Settings',
	'app.component.shipment-manifests': 'Flagged Manifests',
	'app.component.report': 'Reports',
	'app.component.dashboard': 'Home',
	'app.component.customer': 'Customers',
	'app.component.shipment': 'Shipments',
	'app.component.api-key': 'API Key',
	'app.component.billing': 'Billing',
	'app.component.accounts': 'Accounts',
	'app.component.account': 'Account',
	'app.component.account-detatils': 'Account Details',
	'app.account-details.usps-config': 'USPS Config',
	'app.account-details.rateset': 'Rateset',
	'app.account-details.plans-label': 'Plans',
	'app.account-details.product-detail.change-plan-label': 'Change Plan',
	'app.account-details.product-detail.change-plan-dialog-description':
		'Are you sure you want to switch to {0} from {1}',
	'app.component.admin-account-details': 'Details',
	'app.account-details.tier-override-rateSet': 'Tier & Override RateSet',
	'app.admin.carrier-details-list-customsItem-value-configuration-label': 'Max Declared Value',
	'app.admin.carrier-configuration-accordion-Payment-and-Declared-Value-label': 'Billing & Payment',
	'app.admin.carrier-configuration-accordion-Tracking-Range-label': 'Tracking',
	'app.admin.carrier-import-tracking-range-button': 'Import',
	'app.admin.carrier-details-list-tracking-range-last-imported-date': 'Tracking Range Last Imported Date',
	'app.admin.carrier-details-induct-mapping': 'USPS Entry Facility Zip',
	'app.admin.carrier-details-last-refreshed-date': 'Last Refreshed Date',
	'app.admin.carrier-refresh-induct-mapping-button': 'Refresh',
	'app.account-details.account-balance-adjustment': 'Balance & Adjustments',
	'app.account-details.account-balance-adjustment.adjust-button-text': 'Adjust',
	'app.account-details.account-balance-adjustment.debit-dialog-description':
		'Adjusting balance for account: {0}. Are you sure you want to debit ${1}?',
	'app.account-details.account-balance-adjustment.credit-dialog-description':
		'Adjusting balance for account: {0}. Are you sure you want to credit $ {1}?',
	'app.account-details.account-balance-adjustment.credit-dialog-label': 'Adjust Balance',
	'app.account-details.account-balance-adjustment.snackbar-success-message': 'Balance has been adjusted successfully',
	'app.account-details.accoount-balance-adjustment.transaction-label': 'TransactionType',
	'app.account-details.account-balance-adjustment.debit-button-label': 'Debit',
	'app.account-details.account-balance-adjustment.credit-button-label': 'Credit',
	'app.account-details.accoount-balance-adjustment.transaction-label': 'TransactionType',
	'app.component.account-app-detatils': 'Account App Details',
	'app.component.users': 'Users',
	'app.component.webhooks': 'Web Hooks',
	'app.component.signout': 'Sign Out',
	'app.component.app': 'Apps',
	'app.component.report-balance-history': 'Balance History',
	'app.component.report-account-statement': 'A/C Statement',
	'app.component.report-account-statement-by-day': 'A/C Statement By Day',
	'app.component.report-daily-finance': 'Daily Finance',
	'app.component.report-monthly-finance': 'Monthly Finance',

	//General
	'app.genesisAPI-title': 'GenesisAPI',
	'app.label.date-table-header': 'Date',

	// On AppView Component
	'app.app-view.add-app': 'Add App',
	'app.app-view.add-carrier-account': 'Add Carrier Account',
	'app.app-view.my-apps': 'My Apps',
	'app.app-view.all-apps': 'All Apps',
	'app.app-view.app-installed-on': 'Installed on',
	'app.app-view.edit-app': 'Edit App',
	'app.app-view.app-name': 'Name',
	'app.app-view.app-description': 'Description',
	'app.app-view.save-button': 'Save',
	'app.app-view.cancel-button': 'Cancel',
	'app.app-view.next-button': 'Next',
	'app.app-view.back-button': 'Back',
	'app.app-view.install-button': 'Install',
	'app.app-view.app-card.app-access-key': 'App Access Key',
	'app.app-view.app-card.revoke': 'Revoke',
	'app.app-view.app-card.uninstall': 'Uninstall',
	'app.app-view.app-card.edit': 'Edit',
	'app.app-view.app-type': 'Type',
	'app.app-view.api-version': 'API version',
	'app.app-view.help-url': 'Help URL',
	'app.app-view.app-card-fedex-native-download-tracking-range-help': '{link} tracking range(s) from FedEx FUSE',
	'app.app-view.app-card-fedex-native-edit-text': 'Edit',
	'app.app-view.app-card-fedex-native-fuse-link-text': 'Import',
	'app.app-view.app-card.new-app-add-success-message': 'app installed successfully',
	'app.app-view.app-card.new-app-add-appName-required-validation': 'App name is required',
	'app.app-view.app-card.new-app-add-appName-max-validation': 'App name can be maximum of 100 characters long',
	'app.app-view.app-card.new-app-add-apiVersion-required-validation': 'Api Version is required',
	'app.app-view.app-card.new-app-add-apiVersion-max-validation': 'Api Version can be maximum of 100 characters long',
	'app.app-view.app-card.new-app-add-helpUrl-required-validation': 'Help URL is required',
	'app.app-view.app-card.new-app-add-helpUrl-max-validation': 'Help URL is not a valid URL',
	'app.app-view.app-card.new-app-add-appDescription-required-validation': 'App description is required',
	'app.app-view.app-card.new-app-add-appDescription-max-validation':
		'App description can be maximum of 500 characters long',
	'app.app-view.app-card.app-edit-appType-helper-text':
		'It is recommended to finish any unused balance before you switch App Type',
	'app.app-view.app-card.app-edit-appType-genesisApi': 'GenesisAPI',
	'app.app-view.app-card.app-edit-appType-packageHub': 'PackageHub',
	'app.app-view.app-card.app-edit-appType-published-by': 'Published by ',
	'app.app-view.app-card.app-edit-appType-api-version': 'API Version',
	'app.app-view.app-card.app-edit-appType-pending-install': 'Click to install',
	'app.app-card.add-new-label': 'Add new',
	'app.app-card.hide-disabled-apps-label': 'Hide disabled apps',
	'app.app-card.show-disabled-apps-label': 'Show disabled apps',
	'app.carrier-details-label': 'Carrier Details',
	'app.delete-carrier-label': 'Delete Carrier',
	'app.delete-app-label': 'Delete App',
	'app.carrier.enabled-account-status': 'Enable Carrier Account Status',
	'app.carrier.disabled-account-status': 'Disable Carrier Account Status',
	'app.carrier.delete-dialog-description': 'Are you sure you want to delete this carrier?',
	'app.carrier.update-status-dialog-description': 'Are you sure you want to change carrier account status?',
	'app.carrier-configuration-label': 'Carrier Configuration',
	'app.carrier.add-carrier-account-label': 'Add Carrier Account',
	'app.carrier.edit-carrier-account-label': 'Edit Carrier Account',
	'app.carrier-account-id-label': 'Carrier Account Id',
	'app.carrier-account-name-label': 'Carrier Account Name',
	'app.carrier-account-status-label': 'Carrier Account Status',
	'app.carrier-details-name-required-validation': 'Name is required',
	'app.carrier-details-description-required-validation': 'Description is required',
	'app.carrier-details-app-required-validation': 'App is required',
	'app.carrier-details-description-label': 'Description',
	'app.carrier-created-on-label': 'Created on',
	'app.app-details-label': 'App Details',
	'app.scac-select-label': 'Select Carrier',
	'app.carrier-select-label': 'Select Variant',
	'app.carrier-details-label': 'Carrier Details',
	'app.carrier-sender-info-label': "Sender's Info",
	'app.carrier-description-max-length-label': 'Carrier description can have at most 1000 characters',
	'app.carrier-description-default-value': 'Carrier account for {0}',
	'app.carrier-name-max-length-label': 'Carrier name can have at most 100 characters',
	'app.carrier-view-search-placeholder': 'Search carrier name',
	'app.carrier-view-search-by-app-name-placeholder': 'Search by carrier or app name',
	'app.carrier-scac': 'SCAC',
	'app.carrier-account-number-label': 'Account Number',
	'app.carrier-ground-account-number-label': 'Ground Account Number',
	'app.carrier-book-number-label': 'Book Number',
	'app.carrier-page-number-label': 'Page Number',
	'app.carrier-account-number-max-length': 'Account number must be 6 characters',
	'app.carrier-fedex-account-number-max-length': 'Account number must be a 9 digit number',
	'app.carrier-fedex-ground-account-number-max-length': 'Ground account number must be a 7 or 9 digit number',
	'app.carrier-fedex-both-ground-account-number-requried':
		'Ground Account Number is required in both Billing and Shipper configurations to use Ground services',
	'app.carrier-account-number-required': 'Account number is required',
	'app.carrier-ground-account-number-required': 'Ground account number is required',
	'app.carrier-book-number-max-length': 'Book number must be a 7 digit number',
	'app.carrier-book-number-required': 'Book number is required',
	'app.carrier-page-number-max-length': 'Page number must be a 2 digit number',
	'app.carrier-page-number-required': 'Page number is required',
	'app.carrier-meter-number-max-length': 'Meter number must be a 9 digit number',
	'app.carrier-meter-number-required': 'Meter number is required',
	'app.carrier-smartpost-id-max-length': 'SmartPost Id must be a 5 digit number',
	'app.carrier-smartpost-hubId-max-length': 'SmartPost hub Id must be a 4 digit number',
	'app.carrier-smartpost-mailerId-max-length': 'SmartPost mailer Id must be a 9 digit number',
	'app.carrier-smartpost-distributionCenter-max-length': 'SmartPost distribution center must be a 2 digit number',
	'app.carrier-smartpost-id-number-required': 'SmartPost Id is required',
	'app.carrier-smartpost-hubId-required': 'SmartPost hub Id is required',
	'app.carrier-smartpost-mailerId-required': 'SmartPost mailer Id is required',
	'app.carrier-smartpost-distributionCenter-required': 'SmartPost distribution center is required',
	'app.carrier-smartpost-id-number-regex': 'SmartPost Id can only contain numbers',
	'app.carrier-smartpost-hubId-regex': 'SmartPost hub Id can only contain numbers',
	'app.carrier-smartpost-mailerId-regex': 'SmartPost mailer Id can only contain numbers',
	'app.carrier-smartpost-distributionCenter-regex': 'SmartPost distribution center can only contain numbers',
	'app.carrier-account-number-regex': 'Account number only contain number and letter',
	'app.carrier-fedex-account-number-regex': 'Account number can only contain numbers',
	'app.carrier-fedex-ground-account-number-regex': 'Ground account number can only contain numbers',
	'app.carrier-meter-number-regex': 'Meter number can only contain numbers',
	'app.carrier-book-number-regex': 'Book number must be a numeric value',
	'app.carrier-page-number-regex': 'Page number must be a numeric value',
	'app.app-view.tracking-range-button': 'Download Tracking Range',
	'app.carrier-smartpost-checkbox-label': 'Enable Ground Economy',
	'app.carrier-sequence-number-label': 'Tracking Range Current',
	'app.carrier-smartPostId-label': 'SmartPost Id',
	'app.carrier-smartPostMailerId-label': 'SmartPost Mailer Id',
	'app.carrier-smartPostHubId-label': 'SmartPost Hub Id',
	'app.carrier-smartPostDistributionCenter-label': 'SmartPost Distribution Center',
	'app.carrier-alternateId-label': 'Alternate Id',
	'app.carrier-sequence-number-start-label': 'Tracking Range Start',
	'app.carrier-sequence-number-end-label': 'Tracking Range End',
	'app.carrier-sequenceNumber-label': 'Tracking Range Current',
	'app.carrier-sequenceNumberStart-label': 'Tracking Range Start',
	'app.carrier-sequenceNumberEnd-label': 'Tracking Range End',
	'app.carrier-meterNumber-label': 'Meter Number',
	'app.carrier-billingAccountNumber-label': 'Account Number',
	'app.carrier-billingGroundAccountNumber-label': 'Ground Account Number',
	'app.carrier-ground-economy-pickup-carrier-label': 'PickUp Carrier',
	'app.carrier-ground-economy-pickup-FDXG-carrier-label': 'Fedex Ground',
	'app.carrier-ground-economy-pickup-FXSP-carrier-label': 'FedEx Ground Economy',
	'app.carrier-account.FedEx-Native-billing-config-section-header': 'Billing configurations',
	'app.carrier-account.FedEx-Native-shipper-config-section-header': 'Shipper configurations',
	'app.carrier-account.FedEx-Native-rating-config-section-header': 'Rating configurations',
	'app.carrier-account.FedEx-Native-smart-post-config-section-header': 'SmartPost® configurations',
	'app.carrier-account.FedEx-Native-tracking-ranges-section-header': 'Tracking ranges ({edit})',
	'app.carrier-sequenceNumberEnd-required': 'Tracking range end is required',
	'app.carrier-sequenceNumberStart-required': 'Tracking range start is required',
	'app.carrier-sequenceNumber-required': 'Tracking range current is required',
	'app.carrier-sequence-number-range-start': 'Tracking range start must be greater than equal to {0}',
	'app.carrier-sequence-number-range-end-start': 'Tracking range start must be greater than {0}',
	'app.carrier-sequence-number-range-end': 'Tracking range end must be less than equal to {0}',
	'app.carrier-sequence-number-range-current-from-start':
		'Tracking range current must be greater than equal to range start value i.e. {0}',
	'app.carrier-sequence-number-range-current-from-end':
		'Tracking range current must be less than equal to range end value i.e. {0}',
	'app.carrier-sequence-number-range-end-greater-than-start':
		'Tracking range end must be greater than tracking range start',
	'app.carrier-sequence-number-greater-than-start':
		'Current tracking range sequence must be greater than tracking range start',
	'app.carrier-sequence-number-less-than-end': 'Current tracking range sequence must be less than tracking range end',
	'app.carrier-sequence-number-start': 'Tracking range start is required',
	'app.carrier-sequence-number-end': 'Tracking range end is required',
	'app.carrier-sequence-number': 'Tracking range current is required',
	'app.carrier-account.config.returns-mid-label': 'MRA Returns MID',
	'app.carrier-account.config.mid-length-validation': 'Mailer ID must be of length 6 or 9',
	'app.carrier-account.config.crid-length-validation': 'CRID must not be longer than 15 digits',
	'app.carrier-account.config.integer-validation': 'Must only contain numbers',
	'app.carrier-account.config.returns-mid-label-type-validation':
		'MRA Returns MID must be an integer (number w/o decimal)',
	'app.carrier-account.config.mra-account-code-label': 'MRA AccountCode',
	'app.carrier-account.config.mra-account-code-length-validation': 'MRA AccountCode must be of length 32',
	'app.carrier-account.config.mid-account-code-both-required':
		'MRA MID and MRA AccountCode are both required to use MRA',
	'app.carrier-account.config.consumer-key-secret-both-required':
		'Consumer Key and Consumer Secret are both required to change app credentials',
	'app.carrier-account.config.email.tooltip-message':
		'[{ "value": "USPS tracking notifications will be sent to this email in addition to emails specified in fromAddress and toAddress of the shipment."}]',
	'app.carrier-account.config.alternateId.tooltip-message':
		'[{ "value": "This alternate ID will be used for unsupported features to generate shipments using an alternate carrier account."}]',
	'app.carrier-account.config.printAltReturnAddressOnUSPSLabel-label': 'Print Alternate Return Address on label?',
	'app.carrier-account.config.printAltReturnAddressOnUSPSLabel-label.tooltip-message':
		'[{ "value": "Applicable only to /Shipment endpoint." }, { "value": "Package will still be returned to Alteranate Return Address when provided." }, { "value": "Just that it will not be displayed on label when this setting is unchecked." }]',
	'app.carrier-account.config.USPSPrintEntryFacilityNameOnLabel-label':
		'Print entry facility name on ParcelSelectDE labels?',
	'app.carrier-account.config.USPSPrintEntryFacilityNameOnLabel-label.tooltip-message':
		'[{ "value": "Applicable only to /Shipment endpoint." }, { "value": "Supported only for NDC and SCF bound labels." }, { "value": "CustomText2 cannot be used when this is enabled." }]',
	'app.carrier-account.config.ratingMode-label-enabled.tooltip-message':
		'[{ "value": "Applicable only to /Shipment endpoint" }, { "value": "To check rates you may still use /ShipmentRate endpoint" }]',
	'app.carrier-account.config.ratingMode-label-disabled.tooltip-message':
		'[{ "value": "Only availabe for postpaid Carrier Accounts. Please contact support."}, { "value": "If you had this already setup, your configuration is saved. It will be visible again when payment type is changed to Postpaid." }]',
	'app.carrier-account.USPS-shipper-Address-section-header': 'Shipper Address',
	'app.carrier-account.USPS-Rating-Config-section-header': 'Rating configurations',
	'app.carrier-account.USPS-Label-Config-section-header': 'Label configurations',
	'app.carrier-account.USPS-Alternate-Config-section-header': 'Alternate CarrierAccount configurations',
	'app.carrier-account.USPS-Configuration-accordion-label': 'Rating & Label Configurations',
	'app.carrier-account.USPS-MID-accordion-label': 'MID & Payer Configurations',
	'app.carrier-account.USPS-Returns-accordion-label': 'MRA Configurations',
	'app.carrier-account.config.ratingMode-label': 'Rating Mode',
	'app.carrier-account.config.ratingMode-WithShipment-label': 'With Shipment',
	'app.carrier-account.config.ratingMode-WithManifest-label': 'With Manifest',
	'app.carrier-account.config.ratingMode-Disabled-label': 'Disabled',
	'app.carrier-account.config.USPSRequestMappingMode-label': 'USPS Request Mapping',
	'app.carrier-account.config.USPSRequestMappingMode-Normal-label': 'Normal',
	'app.carrier-account.config.USPSRequestMappingMode-HidePhoneEmail-label': 'HidePhoneEmail',
	'app.carrier-account.config.MRA-label-enabled.tooltip-message': '[{ "value": "Return shipment through MRA API"}]',
	'app.carrier-account.config.MRA-label-disabled.tooltip-message':
		'[ { "value": "Only availabe for postpaid Carrier Accounts. Please contact support."}, {"value": "If you had MRA already setup, your configurations are saved. They will be visible again when payment type is changed to Postpaid."}]',
	'app.carrier-account.config.permit-number-required-with-permit':
		'Permit Number is required when Payment Account Type is Permit',
	'app.carrier-account.config.permit-zip-required-with-permit':
		'Permit Zip is required when using Payment Account Type is Permit',
	'app.carrier-account.config.eps-number-required-with-eps':
		'EPS Account Number is required when Payment Account Type is EPS',
	'app.carrier-account.config.permit-zip-length-validation': 'Permit ZIP must be 5 digits long',
	'app.carrier-account-NotEligible': 'Not Eligible',
	'app.carrier-account-Requested': 'Requested',
	'app.carrier-account-Enabled': 'Enabled',
	'app.carrier-account-EnabledWithoutWatermark': 'Enabled(For no watermark)',
	'app.carrier-account-Disabled': 'Disabled',
	'app.carrier-account.MRA-section-header': 'Returns configurations',
	'app.carrier-account.USPS-Ship-app-section-header': 'USPS app credentials',
	'app.carrier-account.USPS-Ship-MailOwner-section-header': 'Mail owner configurations',
	'app.carrier-account.USPS-Ship-shipper-section-header': 'Shipper configurations',
	'app.carrier-account.USPS-Ship-LabelOwner-section-header': 'Label owner configurations',
	'app.carrier-account.USPS-Ship-ReturnLabelOwner-section-header': 'Return label owner configurations',
	'app.carrier-account.USPS-Ship-payment-section-header': 'Payer configurations',
	'app.carrier-account.config.USPSMID-label': 'MID',
	'app.carrier-account.config.USPSManifestMID-label': 'Manifest MID',
	'app.carrier-account.config.USPSMailOwnerMID-label': 'MID',
	'app.carrier-account.config.USPSShipperMID-label': 'MID',
	'app.carrier-account.config.USPSPayerCRID-label': 'CRID',
	'app.carrier-account.config.USPSLabelOwnerCRID-label': 'CRID',
	'app.carrier-account.config.USPSReturnLabelOwnerCRID-label': 'CRID',
	'app.carrier-account.config.USPSShipperCRID-label': 'CRID',
	'app.carrier-account.config.USPSConsumerKey-label': 'Consumer Key',
	'app.carrier-account.config.USPSConsumerSecret-label': 'Consumer Secret',
	'app.carrier-account.config.USPSPaymentAccountType-label': 'Payment Account Type',
	'app.carrier-account.config.USPSPaymentAccountType-Permit-label': 'Permit',
	'app.carrier-account.config.USPSPaymentAccountType-EPS-label': 'EPS',
	'app.carrier-account.config.USPSEPSAccountNumber-label': 'EPS Account Number',
	'app.carrier-account.config.USPSPermitNumber-label': 'Permit Number',
	'app.carrier-account.config.USPSPermitZIP-label': 'Permit ZIP',
	'app.carrier-account.tier-override-USPSeVSWebtoolID-label': 'USPS-eVS Webtools Id',
	'app.carrier-account.tier-override-USPSeVSWebtoolPassword-label': 'USPS-eVS Webtools password',
	'app.carrier-account.tier-override-USPSeVSWebtoolMID-label': 'USPS-eVS Webtools Mailer ID',
	'app.carrier-account.tier-override-USPSMailOwnerMID-label': 'USPS Mail Owner Mailer ID',
	'app.carrier-account.tier-override-USPSeVSMID-label': 'USPS-eVS Mailer ID',

	// On AdminCarrierDetails Component
	'app.carrier-label': 'Carrier',
	'app.service-label': 'Service',
	'app.package-type-label': 'Package Type',
	'app.special-service-label': 'Special Service',
	'app.carrier-status-label': 'Status',
	'app.carrier-id-label': 'Code',
	'app.carrier-code-label': 'Carrier Code',
	'app.carrier-provider-label': 'Provider',
	'app.carrier-name-label': 'Name',
	'app.carrier-scac-label': 'SCAC',
	'app.carrier-services-label': 'Services',
	'app.carrier-package-types-label': 'Package Types',
	'app.carrier-special-services-label': 'Special Services',
	'app.carrier-configuration-label': 'Configuration',
	'app.carrier-tier-override-label': 'Tier Override Configuration',
	'app.service-code-label': 'Code',
	'app.service-name-label': 'Name',
	'app.package-type-code-label': 'Code',
	'app.package-type-name-label': 'Name',
	'app.special-service-code-label': 'Code',
	'app.special-service-name-label': 'Name',
	'app.service-international-label': 'Is International',
	'app.carrier-description-label': 'Description',
	'app.carrier-payment-type-label': 'Payment Type',
	'app.carrier.status-confirm-dialog-text': 'Are you sure you want to update the Carrier?',
	'app.shipment.reprint-label-dialog-text': 'Select the package for reprint label:',
	'app.shipment.package-number': 'Package Num.',
	'app.shipment.all-packages-label': 'All Packages',
	'app.carrier-details.update-config-dialog-title': 'Update Config',
	'app.carrier-details.dialog-description': 'Are you sure you want to update carrier configuration?',
	'app.carrier-details.max-value-validation': 'Max declared value must be greater than equals to 0 and less than {0}',

	// On ApiKeys Component
	'app.api-key.show-credentials': 'Show Credentials',
	'app.api-key.hide-credentials': 'Hide Credentials',
	'app.api-key.regenerate-credentials': 'Regenerate Credentials',
	'app.api-key.prod-credentials': 'Live Credentials',
	'app.api-key.test-credentials': 'Test Credentials',
	'app.api-key.test-info': 'Test credentials are only supported for USPS-eVS and USPS-ePostage carriers',
	'app.api-key.api-key': 'API Key',
	'app.api-key.api-secret': 'API Secret',
	'app.api-key.copied-to-clipboard': 'Copied to clipboard',
	'app.api-key.credentials-regenerated': 'Credentials generated successfully',
	'app.api-key.credentials-regenerate-confirm-message':
		'Are you sure you want to regenerate credentials. This will automatically revoke existing credentials.',
	'app.api-key.customer-signup-url': 'Customer SignUp URL',
	'app.api-key.api-key-secret': 'API Key-Secret',
	'app.api-key.add-customer': 'Add Customer',
	'app.api-key.embedded-partner-signup-url': 'Embed',
	'app.api-key.customer-email': 'Customer Email',
	'app.api-key.customers': 'Customers',
	'app.api-key.email-sent-successfully': 'Email sent successfully',
	'app.api-key.carrier-account-label': 'Carrier Account',
	'app.api-key.visible-account-number': 'Visible Account Number',
	'app.api-key.api-version': 'API Version',
	'app.api-key.installed-on': 'Installed on',
	'app.api-key.code-samples-and-sdk': 'Code samples & SDKs',
	'app.api-key.code-samples-and-sdk-description':
		'Use PackageHub code samples and SDKs to simplify development with PackageHub APIs',
	'app.api-key.code-samples-and-sdk-action-button': 'Learn More',

	// On CarrierAdminDetails component
	'app.carrier-status-label': 'Status',

	// On CarrierDetails component
	'app.carrier-details.app-label': 'App',

	// On CarrierCard component
	'app.carrier-card.app-name-label': 'App Name',
	'app.carrier-card.configure-dialog-title': 'Configure carrier account',
	'app.carrier-card.payment-type-label': 'Payment Type',
	'app.carrier-card.accordin-payment-mode-label': 'Payment Mode',
	'app.carrier-card.auto-manifest-schedules-label': 'AutoManifest Schedules',
	'app.carrier-card.carrier-payment-type-label': 'Carrier Default',
	'app.carrier-card.configuration-update-successful': 'Configuration has been updated successfully',

	// Login Page Component
	'app.login.login-box-heading': 'Welcome back!',
	'app.login.login-box-subheading': 'Login to your account',
	'app.login.email-label': 'Email / UserName',
	'app.login.password-label': 'Password',
	'app.login.stay-logged-in-message': 'Stay logged in',
	'app.login.signin-button-text': 'Sign In',
	'app.login.forgot-password-text': 'Forgot Password?',
	'app.login.signup-suggest-text-customer': "Don't have a customer account?",
	'app.login.signup-suggest-button-text': 'Get Started',
	'app.login.signin-email-required-validation': 'Email is required',
	'app.login.signin-email-invalid-validation': 'Please enter a valid email address (Ex: johndoe@domain.com)',
	'app.login.signin-password-required-validation': 'Password is required',
	'app.login.forgot.password-dialog-title': 'Forgot Password',
	'app.login.forgot.password-dialog-description':
		' To reset your password, please enter your registered email address here. We will send reset password link to your email.',
	'app.login.forgot.password.invalid-email-validation': 'Please enter a valid email address (Ex: johndoe@domain.com)',
	'app.login.forgot.password.email-required-validation': 'Please enter a valid email address (Ex: johndoe@domain.com)',
	'app.login.forgot.password.send-button': 'Send',

	// Signup Page Component
	'app.signup.signup-box-heading-partner': 'Create a new partner account',
	'app.signup.signup-box-heading-customer': 'Create a new customer account',
	'app.signup.company-name-label': 'Company',
	'app.signup.first-name-label': 'First Name',
	'app.signup.last-name-label': 'Last Name',
	'app.signup.email-label': 'Email',
	'app.signup.password-label': 'Password',
	'app.signup.signup-button-text': 'Sign Up',
	'app.signup.signin-suggest-text': 'Already Registered?',
	'app.signup.signin-suggest-button-text': 'Sign In',
	'app.signup.signin-email-verified-successfully': 'Email verified successfully',
	'app.signup.signin-email-not-verified': 'Email not verified. Please try again',
	'app.signup.signup-form.company-min-length-required-validation': 'Too Short!',
	'app.signup.signup-form.company-max-length-required-validation': 'Too Long',
	'app.signup.signup-form.company-name-required-validation': 'Company is required',
	'app.signup.signup-form.email-required-validation': 'Email required',
	'app.signup.signup-form.email-length-validation': 'Email must be at most {0} characters',
	'app.signup.signup-form.email-invalid-validation': 'Please enter a valid email address (Ex: johndoe@domain.com)',
	'app.signup.signup-form.password-required-validation': ' Password required',
	'app.signup.signup-form.first-name-length-validation': 'First Name must be at most {0} characters',
	'app.signup.signup-form.first-name-required-validation': ' First name is required',
	'app.signup.signup-form.last-name-required-validation': ' Last name is required',
	'app.signup.signup-form.last-name-length-validation': 'Last Name must be at most {0} characters',
	'app.signup.apiKey-label': 'Signup Key',
	'app.signup.signup-form.apikey-validation': 'Signup Key is required',
	'app.signup.signup-form.signup-key': 'I have Signup key',
	'app.signup.company-name-regex-validation': 'Company should not contain any special characters',

	// Invitation Page Component
	'app.signup.signup-form.terms-and-conditions': 'Terms & Conditions',
	'app.signup.signup-form.accept-our-terms-label': 'Accept our ',

	// Invitation Page Component
	'app.invitation.invitation-dear-customer': 'Dear Customer!',
	'app.invitation.invitation-description-by': 'You are invited by ',
	'app.invitation.invitation-description-access': ' to access ',
	'app.invitation.partner-invitation-description-access': ' to PackageHub.',
	'app.invitation.invitation-description-published-by': ' published by ',
	'app.invitation.invitation-thanks-and-regard': 'Thanks & Regards',

	// Billing Page Component
	'app.billing.purchase-postage-label': 'Add Funds',
	'app.billing.purchase-current-balance-label': 'Current Balance',
	'app.billing.purchase-amount-label': 'Amount',
	'app.billing.purchase-button-text': 'Add',
	'app.billing.purchase-confirm-dialog-text': 'Are you sure you want to add funds?',
	'app.billing.purchase-confirm-dialog-purchase-button-text': 'Add',
	'app.billing.purchase-confirm-dialog-cancel-button-text': 'Cancel',
	'app.billing.payment-method-charge-amount-label': 'Your payment method will be charged the amount entered',
	'app.billing.view-report': 'View ',
	'app.billing.auto-buy-label': 'Auto Buy',
	'app.billing.auto-buy-toggle-text-on': 'On',
	'app.billing.auto-buy-toggle-text-off': 'Off',
	'app.billing.auto-buy-amount-label': 'Auto Buy Amount',
	'app.billing.auto-buy-when-balance-reaches-label': 'When Balance reaches',
	'app.billing.auto-buy-update-button-text': 'Update',
	'app.billing.auto-buy-confirm-dialog-text':
		'Please confirm that you would like to update the AutoBuy feature. Postage will automatically be purchased when it hits the threshold shown below',
	'app.billing.auto-buy-confirm-dialog-confirm-button-text': 'Confirm',
	'app.billing.auto-buy-confirm-dialog-cancel-button-text': 'Cancel',
	'app.billing.purchase-postage-amount-required-validation': 'Amount is required',
	'app.billing.purchase-postage-amount-min-length-validation': 'Amount must be greater than or equal to $',
	'app.billing.purchase-postage-amount-max-length-validation': 'Amount must be less than or equal to $',
	'app.billing.auto-buy-amount-required-validation': 'Auto buy amount is required',
	'app.billing.auto-buy-amount-min-length-validation': 'Auto buy amount must be greater than or equal to $',
	'app.billing.auto-buy-amount-max-length-validation': 'Auto buy amount must be less than or equal to $',
	'app.billing.auto-buy-threshold-required-validation': 'Amount is required',
	'app.billing.auto-buy-threshold-min-length-validation': 'Amount must be greater than or equal to $',
	'app.billing.auto-buy-threshold-max-length-validation': 'Amount must be less than or equal to $',
	'app.billing.auto-buy-bill-update-successfully': 'Bill updated successfully',
	'app.billing.payment-method-label': 'Payment Method',
	'app.billing.payment-method-select-label': 'Please choose a method:',
	'app.billing.payment-payment-information-label': 'Payment Information',
	'app.billing.payment-method-name-label': 'Name',
	'app.billing.payment-method-card-number-label': 'Card Number',
	'app.billing.payment-method-security-code-label': 'Security Code',
	'app.billing.payment-method-routing-number-label': 'Routing Number',
	'app.billing.payment-method-account-number-label': 'Account Number',
	'app.billing.payment-method-country-label': 'Country',
	'app.billing.payment-method-state-label': 'State',
	'app.billing.payment-method-address1-label': 'Address1',
	'app.billing.payment-method-address2-label': 'Address2',
	'app.billing.payment-method-city-label': 'City',
	'app.billing.payment-method-postal-label': 'Postal',
	'app.billing.payment-method-phone': 'Phone',
	'app.billing.payment-method-expiry-date-label': 'Expiry Date',
	'app.billing.payment-method-billing-info-label': 'Billing Information',
	'app.billing.payment-security-code-max-length-validation': 'Code must be less than or equals to 4 digits',
	'app.billing.payment-security-code-min-length-validation': 'Code must be greater than or equals to 3 digits',
	'app.billing.payment-card-number-length-validation': 'Card number is invalid',
	'app.billing.payment-account-number-min-length-validation': 'Account number must have minimum 8 digits',
	'app.billing.payment-account-number-max-length-validation': 'Account number must have maximum 16 digits',
	'app.billing.payment-routing-number-length-validation': 'Routing number must be equals to 9 digits',
	'app.billing.payment-name-required-validation': 'Name is required',
	'app.billing.payment-account-number-required-validation': 'Account number is required',
	'app.billing.payment-routing-number-required-validation': 'Routing number is required',
	'app.billing.payment-card-number-required-validation': 'Card number is required',
	'app.billing.payment-country-required-validation': 'Country is required',
	'app.billing.payment-state-required-validation': 'State is required',
	'app.billing.payment-city-required-validation': 'City is required',
	'app.billing.payment-postal-code-required-validation': 'Postal code is required',
	'app.billing.payment-phone-required-validation': 'Phone is required',
	'app.billing.payment-security-code-required-validation': 'Security code is required',
	'app.billing.payment-expiry-date-required-validation': 'Expiry date is required',
	'app.billing.payment-address1-required-validation': 'Address1 is required',
	'app.billing.payment-card-pattern-string': 'XXXXXXXXXXXX',
	'app.billing.payment-account-number-pattern-string': 'XXXX',
	'app.billing.payment-make-default-tag': 'Make this as default',
	'app.billing.payment-disabled-default-tag': 'Default',
	'app.billing.payment-button-cancel-tag': 'Cancel',
	'app.billing.payment-button-configure-tag': 'Configure',
	'app.billing.payment-security-code-numeric-validation': 'Security Code should contain numeric values only',
	'app.billing.payment-card-numeric-validation': 'Credit Card should contain numeric values only',
	'app.billing.payment-postal-code-numeric-validation': 'Postal Code should contain numeric values only',
	'app.billing.payment-account-number-numeric-validation': 'A/C should contain numeric values only',
	'app.billing.payment-method-none': 'No payment methods configured.',
	'app.billing.purchase-postage-successfully': 'Postage purchased successfully',
	'app.billing.auto-buy-updated-successfully': 'Auto Buy settings updated successfully',
	'app.billing.payment-card-number-info': 'As it appears on card',

	//Profile Component
	'app.profile-label': 'Profile',
	'app.account.company-label': 'Company',
	'app.account.name-label': 'Name',
	'app.account.description-label': 'Description',
	'app.account.level-type': 'Account Level',
	'app.account.type-GenesisAPI': 'GE',
	'app.account.type-PackageHub': 'PH',
	'app.account.name-lebel': 'Account Name',
	'app.account.balance-lebel': 'Account Balance',
	'app.account.partner-visible-account-label': 'Partner',
	'app.account.customer-visible-account-label': 'Company',
	'app.account.id-label': 'Account Id',
	'app.account.partner-visible-account': 'Partner',
	'app.account.admin-account-status-label': 'Status',
	'app.profile-user-info-form.first-name-label': 'First Name',
	'app.profile-user-info-form.last-name-label': 'Last Name',
	'app.profile.user-info-form.email-label': 'Email',
	'app.profile.user-info-form.username-label': 'UserName',
	'app.profile.user-info-form.visible-account-number-label': 'PackageHub A/C',
	'app.profile.change-password-form.change-password-label': 'Change Password',
	'app.profile.change-password-form.old-password-label': 'Old Password',
	'app.profile.change-password-form.new-password-label': 'New Password',
	'app.profile.change-password-form.confirm-password-label': 'Confirm Password',
	'app.profile.change-password-form.password-chang-due-date-label': 'Password Change Due Date',
	'app.profile.company-form.company-label': 'Sender Info',
	'app.account.senderInfo-form-label': 'Fill the sender information below to use the USPS ePostage carrier',
	'app.profile.company-form.company-name-label': 'Company',
	'app.profile.company-form.company-address-street1-label': 'Street 1',
	'app.profile.company-form.company-address-street2-label': 'Street 2',
	'app.profile.company-form.company-address-street3-label': 'Street 3',
	'app.profile.company-form.company-address-city-label': 'City',
	'app.profile.company-form.company-address-state-label': 'State',
	'app.profile.company-form.company-address-zip-label': 'Zip',
	'app.profile.company-form.company-address-country-label': 'Country',
	'app.profile.company-form.name-required-validation': 'Name is required',
	'app.profile.company-form.fullName-validation': 'Name should contain first and last name',
	'app.profile.company-form.company-name-required-validation': 'Company is required',
	'app.profile.company-form.city-name-required-validation': 'City is required',
	'app.profile.company-form.country-name-required-validation': 'Country is required',
	'app.profile.company-form.zip-required-validation': 'Zip is required',
	'app.profile.company-form.state-name-required-validation': 'State is required',
	'app.profile.company-form.street1-required-validation': 'Street is required',
	'app.profile.company-form.company-address-phone-label': 'Phone',
	'app.profile.company-form.phone-required-validation': 'Phone is required',
	'app.profile.company-form.phone-validation': 'Phone number is not valid',
	'app.profile.company-form.company-address-email-label': 'Email',
	'app.profile.user-info-form.first-name-required-validation': 'First name is required',
	'app.profile.user-info-form.first-name-max-length-validation': 'First name can have at most 100 characters',
	'app.profile.user-info-form.last-name-required-validation': 'Last name is required',
	'app.profile.user-info-form.last-name-max-length-validation': 'Last name can have at most 100 characters',
	'app.profile.change-password-form.new-password-required-validation': 'New password is required',
	'app.profile.change-password-form.confirm-password-required-validation': 'Confirm password is required',
	'app.profile.change-password-form.old-password-required-validation': 'Old password is required',
	'app.profile.user-info-form.save-button-text': 'Save',
	'app.profile.company-address-form.save-button-text': 'Validate & Save',
	'app.profile.user-info-form.resend-verification-mail': 'Check your mail, we have sent you a verification mail',
	'app.profile.user-info-form.save-button-text': 'Save',
	'app.profile.user-info-form.resend-verification-mail-text': 'Resend Verification Email',
	'app.profile.logo': 'Logo',
	'app.profile.change-password-form.new-password.confirm.password-validation':
		"The new password & confirm password doesn't match",
	'app.profile.user-info-form.close-account-dialog-box-title': 'Close Account',
	'app.profile.user-info-form.close.account-dialog-box-description':
		'Maersk will review your account and refund any prepaid balance if necessary. Receipt of the refund could take between two and four weeks.',
	'app.admin-details.user-info-form.close.account-dialog-box-description':
		'Maersk will review this account and refund any prepaid balance if necessary. Receipt of the refund could take between two and four weeks.',
	'app.profile.user-info-form.close.account-link': 'Close Account',
	'app.profile.user-info-form.account-closed-label': 'Account closed',
	'app.profile.user-info-form.account-closed-button': 'Confirm',
	'app.profile.user-info-form.close-account-validation': 'Reason is required',
	'app.profile.user-info-form.close-account-label': 'Reason',
	'app.profile.change-password-form.regex-validation':
		'Invalid password, minimum 8 characters with 1 upper case, 1 lower case, 1 number required',
	'app.profile.change-password-form.user-account-name-validation':
		'Invalid password, it should not contain your name or company name',
	'app.profile.default-app': 'Default App',
	'app.profile.company-address-validate-info': 'USPS address validation API might update address data',
	'app.profile.user-close-account-label':
		'You are not authorized to close an account. Contact your account admin {0} or contact Package Hub support at support.packagehub@maersk.com',

	//Profile Messages
	'app.user.add-user-label': 'Add User',
	'app.user.update-user-label': 'Edit User',
	'app.user.update-label': 'Edit',
	'app.user.role-label': 'Role',
	'app.user.add-button': 'Add',
	'app.user.cancel-button': 'Cancel',
	'app.user.save-button': 'Save',
	'app.user.users': 'Users',
	'app.user.role-Admin': 'Admin',
	'app.user.role-AccountAdmin': 'Account Admin',
	'app.user.role-User': 'User',
	'app.user.role-ReadOnlyAdmin': 'Read Only Admin',
	'app.user.delete': 'Delete',
	'app.user.enable': 'Enable',
	'app.user.disable': 'Disable',
	'app.user.delete-dialog-title': 'Delete User',
	'app.user.delete-dialog-description': 'Are you sure you want to delete this user?',
	'app.user.delete-successfully': 'User has been deleted successfully',
	'app.user.add-user-successfully': 'User has been added successfully',
	'app.user.resend-invite': 'Resend Invite',
	'app.user.resend-invite-dialog-description': 'Do you want to send invite again?',

	//SnackBar Messages
	'app.snackbar.something-went-wrong': 'Something went wrong',
	'app.snackbar.password-change-due-date-expired': 'Please change your password immediately to avoid any inconvenience',
	'app.snackbar.password-changed-successfully': 'Password changed successfully',
	'app.snackbar.profile-updated-successfully': 'Profile updated successfully',
	'app.snackbar.reset-password-email-wrong': 'Email or security code not found',
	'app.snackbar.reset-password-successfully': 'Your password has been reset successfully',
	'app.snackbar.reset-email-link': 'Password reset link has been sent to your email',
	'app.snackbar.company-address-saved-successfully': 'Sender Info saved successfully',
	'app.snackbar.close-account-successfully': 'Account has been closed successfully',
	'app.snackbar.profile-payment-method-successfully': 'Payment Method updated successfully',
	'app.snackbar.app-added-successfully': 'App added successfully',
	'app.snackbar.app-updated-successfully': 'App has been updated successfully',
	'app.snackbar.app-enabled-successfully': 'App has been enabled successfully',
	'app.snackbar.app-disabled-successfully': 'App has been disabled successfully',
	'app.snackbar.app-deleted-successfully': 'App has been deleted successfully',
	'app.snackbar.carrier-added-successfully': 'Carrier added successfully',
	'app.snackbar.carrier-deleted-successfully': 'Carrier has been deleted successfully',
	'app.snackbar.carrier-updated-successfully': 'Carrier has been updated successfully',
	'app.snackbar.carrier-auto-manifest-added-successfully': 'AutoMaifest schedule added successfully',
	'app.snackbar.carrier-auto-manifest-deleted-successfully': 'AutoMaifest schedule deleted successfully',
	'app.snackbar.carrier-auto-manifest-status-change-successfully': 'AutoMaifest status changed successfully',
	'app.snackbar.carrier-auto-manifest-updated-successfully': 'AutoMaifest schedule updated successfully',
	'app.snackbar.carrier-account-enabled-successfully': 'CarrierAccount has been enabled successfully',
	'app.snackbar.carrier-account-disabled-successfully': 'CarrierAccount has been disabled successfully',
	'app.snackbar.service-updated-successfully': 'Service has been updated successfully',
	'app.snackbar.special-service-updated-successfully': 'Special Service has been updated successfully',
	'app.snackbar.package-type-updated-successfully': 'Package Type has been updated successfully',
	'app.snackbar.service-enabled-successfully': 'Service has been enabled successfully',
	'app.snackbar.service-disabled-successfully': 'Service has been disabled successfully',
	'app.snackbar.special-service-enabled-successfully': 'Special Service has been enabled successfully',
	'app.snackbar.special-service-disabled-successfully': 'Special Service has been disabled successfully',
	'app.snackbar.requested-carrier-added-successfully':
		'Your Carrier Account request is successfully submitted for processing',
	'app.snackbar.usps-tier-config-added-successfully': 'Tier configuration added successfully',
	'app.snackbar.usps-tier-config-updated-successfully': 'Tier configuration has been updated successfully',
	'app.snackbar.usps-tier-config-deleted-successfully': 'Tier configuration deleted successfully',
	'app.snackbar.tracking-range-import-for-carrier-account': 'Tracking range imported for {0} carrier account(s)',
	'app.snackbar.induct-mapping-refresh-successful': 'Entry facility zip successfully refreshed',
	'app.snackbar.carrier-account-config-update-successful': 'Carrier account configuration updated successfully',
	'app.snackbar.usps-tier-config-default-label': 'Default',
	'app.snackbar.minimum-apps-required-per-account': 'Minimum {0} app(s) are required in each account',

	'app.profile.mid-length.regex-validation': 'MID length must be of 9 digits',
	'app.usps-tier-config-default-yes-label': 'Yes',
	'app.usps-tier-config-default-no-label': 'No',
	'app.usps-tier-config-global-label': 'Global',
	'app.snackbar.user-invitation-sent-successful': 'Invitation has been sent successfully',
	'app.usps-tier-config-remote-label': 'Remote',
	'app.usps-tier-config-local-label': 'Local',
	'app.usps-tier-config-default-label': 'Default',

	//Reset Component
	'app.reset.password-title': 'Reset Your Password',
	'app.reset.password.reset-password-form.password-confirm-password-same-valiation':
		'Password and confirm password are not same',
	'app.reset.password.reset-password-form.confirm-password-required-validation': 'Confirm password is required',
	'app.reset.password.reset-password-form.password-required-validation': 'Password is required',
	'app.reset.password.reset-password-form.min-password-length-validation': 'Password must have at least 8 characters',
	'app.reset.password.reset-password-form.max-password-length-validation': 'Password can have at most 50 characters',
	'app.reset.password.reset-password-form.reset-password-label': 'Reset Password',

	//Dashboard Component
	'app.dashboard-welcome': 'Welcome',
	'app.dashboard-please-complete': 'Please complete your',
	'app.dashboard-start-shipping': ' on portal to start shipping',
	'app.dashboard-total-shipment': 'Total Shipment',
	'app.dashboard-shipment-cost': 'Shipment Cost',
	'app.dashboard-number-of-shipment': 'Number of Shipment',
	'app.dashboard-total-cost': 'Total Cost',
	'app.dashboard-special-service-cost': 'Special Services Cost',
	'app.dashboard-max-balance-limit': 'Max Balance Limit',
	'app.dashboard-fees': 'Fees',
	'app.dashboard-transactions': 'Transactions',
	'app.dashboard-transaction-fees': 'Transaction Fees',
	'app.dashboard-complete-profile': 'Complete Your Profile',
	'app.dashboard-user-information': 'User Information',
	'app.dashboard-payment-details': 'Payment Details',
	'app.dashboard-usps-epostage-shipper-details': 'USPS ePostage Shipper Details',
	'app.dashboard-carrier-account': 'Carrier  Account',
	'app.dashboard-click-to-complete': 'Click to complete',
	'app.dashboard-prepay-widget-title': "Today's summary - Prepay",
	'app.dashboard-postpay-widget-title': "Today's summary - Postpay",
	'app.dashboard.change-password-link': 'Change password now',

	//Balance History Component
	'app.balance-history.current-balance': 'Current Balance',
	'app.balance-history.add-balance': 'Add balance to your account instantly',
	'app.balance-history.add-balance-small-screen': 'Add balance',
	'app.balance-history.date-table-header': 'Date',
	'app.balance-history.event-table-header': 'SubType',
	'app.balance-history.comments-table-header': 'Comments',
	'app.balance-history.description-table-header': 'Description',
	'app.balance-history.type-table-header': 'Type',
	'app.balance-history.balance-table-header': 'Balance',
	'app.balance-history.transaction-id-table-header': 'Transaction Id',
	'app.balance-history.amount-table-header': 'Amount',
	'app.balance-history.start-date-label': 'Start',
	'app.balance-history.end-date-label': 'End',
	'app.balance-history.event-label-OnLabelGenerate': 'Label Printed',
	'app.balance-history.event-label-OnLabelRefund': 'Refund',
	'app.balance-history.event-label-OnPostagePurchase': 'Add Fund',
	'app.balance-history.event-label-OnAutoBuyPurchase': 'Add Fund - Auto Buy',
	'app.balance-history.event-label-APVShortPay': 'APV - ShortPay',
	'app.balance-history.event-label-APVOverPay': 'APV - OverPay',
	'app.balance-history.event-label-BillingCredit': 'Billing Credit',
	'app.balance-history.event-label-AdjustmentDebit': 'Adjustment Debit',
	'app.balance-history.event-label-AdjustmentCredit': 'Adjustment Credit',
	'app.balance-history.event-label-AdjustmentDebit_AddFund': 'Adjustment_AddFund',
	'app.balance-history.more-filters': 'More Filters',
	'app.balance-history.event-filter': 'SubType',
	'app.balance-history.transaction-type-filter': 'Type',
	'app.balance-history.transaction-type-label-Debit': 'Debit',
	'app.balance-history.transaction-type-label-Credit': 'Credit',
	'app.balance-history.download-receipt-label': 'Download Receipt',

	//Shipment Component
	'app.shipment.app-label': 'App',
	'app.shipment.tracking-number': 'Tracking Number',
	'app.shipment.status': ' Status',
	'app.shipment.refund-status': ' Refund Status',
	'app.shipment.shipment-list-item-text': 'Shipment to ',
	'app.shipment.start-date-label': 'Start',
	'app.shipment.end-date-label': 'End',
	'app.shipment.ship-date': 'Ship Date',
	'app.shipment.number-of-packages': 'Number of Packages',
	'app.shipment.toAddress': 'Ship To',
	'app.shipment.package-info': 'Package Info',
	'app.shipment.fromAddress': 'Ship From',
	'app.shipment.otherInfo': 'Other Info',
	'app.shipment.from-address-zip': 'From Zip',
	'app.shipment.to-address-zip': 'To Zip',
	'app.shipment.transactionId': 'Transaction Id',
	'app.shipment.reprint-label': 'Reprint Label',
	'app.shipment.label-info': 'Label Info',
	'app.shipment.package-purchase-details': 'Package Purchase Details',
	'app.shipment.total-amount': 'Total Amount',
	'app.shipment.package-total-amount': 'Total amount for this package',
	'app.shipment.amount': 'Amount',
	'app.shipment.package-packagetype': 'Package Type',
	'app.shipment.package-dimension': 'Dimensions',
	'app.shipment.label-print-label': 'Print Label',
	'app.shipment.label-cubic-unit': 'cubic units',
	'app.shipment.package.tracking-number': 'Package Tracking Number',
	'app.shipment.package-weight': 'Weight',
	'app.shipment.no-data-available': 'No Data',
	'app.shipment.serviceType': 'Service Type',
	'app.shipment.special-service': 'Special Service',
	'app.shipment.service': 'Service',
	'app.shipment.manifest': 'Manifest Number',
	'app.shipment.all-apps': 'All Apps',
	'app.shipment.all-carrierAccounts': 'All',
	'app.shipment.all-accounts': 'All Accounts',
	'app.shipment.account-info': 'Account Info',
	'app.shipment.account-table-header': 'Account Id',
	'app.shipment.rate-label': 'Rate',
	'app.shipment.manifest-status-label': 'Manifest Status',
	'app.shipment.rate-credit-fee-label': 'Credit Card Fee',
	'app.shipment.rate-client-fee-label': 'Client Fee',
	'app.shipment.rate-partner-fee-label': 'Partner Fee',
	'app.shipment.reprint-button-text': 'Reprint Label',
	'app.shipment.refund-button-text': 'Refund Shipment',
	'app.shipment.refund-status-dialog-text': 'Are you sure you want to refund this shipment?',
	'app.shipment.refund-status-dialog-title': 'Refund Shipment',
	'app.shipment.refund-shipment-status-snackbar': 'Shipment has been refunded successfully',
	'app.shipment.more-than-one-package-label': ' (+{0} more)',
	'app.shipment.package-label': 'Package',
	'app.shipment.master-package-chip-label': 'Master',
	'app.shipment.purchase-details': 'Purchase Details',
	'app.admin.shipment-include-other-charges': 'With Other Fees',
	'app.admin.shipment-internal-reporting-label': 'Internal Reporting',
	'app.shipment.min-tracking-number-placeholder': 'Minimum 3 characters',
	'app.shipment.min-tracking-number-helper-text': 'Please type minimum 3 characters',
	'app.shipment.manifest-button-text': 'Download Manifest',
	'app.shipment.carrier-file-button-text': 'Download e-File',
	'app.shipment.update-tracking-button-text': 'Refresh Tracking',
	'app.shipment.rate-column-norated': 'Not Rated',
	'app.shipment.update-tracking-success': 'Tracking status updated for tracking number {trackingNumber}',
	'app.shipment.filter.shipment-rating': 'Shipment Rating',
	'app.shipment.non-native-manifest-status-warning':
		'This status may not be updated as currently PHv3 tracks manifest status only for Native carriers (eVS-Native, ePostage-Native, FedEx-Native)',
	'app.shipment.done': 'Done',
	'app.shipment.all-label': 'All',

	//manifest component
	'app.manifest.tracking-number-table-header': 'Tracking Number',
	'app.manifest.carrier-code-table-header': 'Carrier Code',
	'app.manifest.account-name-table-header': 'Account Name',
	'app.manifest.ship-date-table-header': 'Ship Date',
	'app.manifest.download-error-link-table-data': 'Errors',
	'app.manifest.download-warning-link-table-data': 'Warnings',
	'app.manifest.retry-button-table-data': 'Retry',
	'app.manifest.retry-action-success': 'Retry initiated successfully',
	'app.manifest.retry-action-failure': 'Retry failed. Please try after some time.',
	'app.manifest.status-table-header': 'Status',
	'app.manifest.reattempt-table-header': 'Reattempt',
	'app.manifest.filter.manifest-status': 'Manifest Status',


	//Customer Component
	'app.customer-joining-date': 'Joining Date',
	'app.customer-last-login-date': 'Last Login Date',
	'app.customer-status': 'Status',
	'app.customer-send': 'Send',
	'app.customer.share-app': 'Share App',
	'app.customer.filter-app': 'App',
	'app.customer.shipment-count': 'Shipment Count',
	'app.customer.admin-account-level-filter': 'Level',
	'app.customer.normal-sign-up-label': 'Normal Signup',
	'app.customer.quick-sign-up-label': 'Quick Signup',
	'app.customer.normal-sign-up-description-part-I':
		'Use this flow for customers signing up directly on the PackageHub portal.',
	'app.customer.normal-sign-up-description-part-II':
		'Customers will be able to manage payment info and KEY SECRET within the PackageHub portal.',
	'app.customer.quick-sign-up-description-part-I':
		'Use this flow for customers signing up for a Visible account in 3rd party applications.',
	'app.customer.quick-sign-up-description-part-II':
		'Customers may provide payment info, and once an account is created they will immediately get their KEY SECRET right after signup.',

	//Filter Fields
	'app.filter-select-all': 'Select All',
	'app.filter-all': 'All',
	'app.filter-done': 'Done',
	//Account Statement By Day Component
	'app.account-statement-by-day.date-table-header': 'Date',
	'app.account-statement-by-day.credit-transactions-table-header': 'Credit Transactions',
	'app.account-statement-by-day.debit-transactions-table-header': 'Debit Transactions',
	'app.account-statement-by-day.credit-amount-table-header': 'Credit Amount',
	'app.account-statement-by-day.debit-amount-table-header': 'Debit Amount',
	'app.account-statement-by-day.daily-balance-table-header': 'Daily Balance',
	'app.account-statement-by-day.total-balance-table-header': 'Total Balance',

	//Daily Finance Component
	'app.daily-finance.date-table-header': 'Date',
	'app.daily-finance.beginning-balance-table-header': 'Beginning Balance',
	'app.daily-finance.funds-added-table-header': 'Funds Added',
	'app.daily-finance.funds-printed-table-header': 'Funds Printed',
	'app.daily-finance.funds-refunded-table-header': 'Funds Refunded',
	'app.daily-finance.ending-balance-table-header': 'Ending Balance',

	//Monthly Finance Component
	'app.monthly-finance.date-table-header': 'Date',
	'app.monthly-finance.beginning-balance-table-header': 'Beginning Balance',
	'app.monthly-finance.funds-added-table-header': 'Funds Added',
	'app.monthly-finance.funds-printed-table-header': 'Funds Printed',
	'app.monthly-finance.funds-refunded-table-header': 'Funds Refunded',
	'app.monthly-finance.ending-balance-table-header': 'Ending Balance',

	//App Select Component
	'app.app-select.select-app': 'Select App',

	// Setting component
	'settings.system-setting': 'System Settings',
	'settings.credit-card-fee-label': 'Credit Card Fee',
	'settings.credit-card-fee-snackbar': 'System settings has been updated successfully',
	'settings.credit-card-fee-required': 'Value is required',
	'settings.credit-card-fee-min': 'Value must be greater than or equal to 0',
	'settings.credit-card-fee-max': 'Value must be less than or equal to 100',
	'settings.usps-config-label': 'USPS Tier Configurations',
	'settings.uspsmid-type-label': 'USPS MID Type',
	'settings.usps-mid-type-label-Returns': 'Returns',
	'settings.usps-mid-type-label-Outbound': 'Outbound',
	'settings.uspsmid-accordion-label': 'USPS MID',
	'settings.uspsmid-file-label': 'USPS MID File',
	'settings.uspsmid.import-button-text': 'Import MID',
	'settings.uspsmid.import-uspsmid-success-snackbar': 'USPS MID has been imported sucessfully',
	'settings.uspsmid.import-uspsmid-select-button': 'Select',
	'settings.uspsmid.import-default-text-textbox': 'No file chosen',
	'settings.uspsmid.download-button-text': 'Download',
	'settings.uspsmid.reset-button-text': 'Reset',
	'settings.uspsmid.error-file-text':
		'Invalid USPS MID(s) in uploaded file. Please download & reverify the error file before uploading again.',
	'settings.uspsmid.available-mids-count-text': 'Available MIDs Count',

	// USPSTierConfig component
	'usps-tier-config.add-label': 'Add USPS Tier',
	'usps-tier-config.tier-label': 'Tier',
	'usps-tier-config.tier-config-label': 'Tier Config',
	'usps-tier-config.tier-returns-config-label': 'Tier Config (Returns)',
	'usps-ship-app-credentials-label': 'USPS app credentials',
	'usps-tier-config.account-type-label': 'Account Type',
	'usps-tier-config.default-rate-label': 'Rate Set',
	'usps-tier-config.rate-set-name-label': 'Name',
	'usps-tier-config.rate-set-description-label': 'Description',
	'usps-tier-config.rate-set-rate-card-name-label': 'Visible Rate Set Name',
	'usps-tier-config.rate-set-rate-set-id-label': 'Visible Rate Set Id',
	'usps-tier-config.master-mid-label': 'Master MID',
	'usps-tier-config.mail-owner-mid-label': 'Mail Owner MID',
	'usps-tier-config.eVS-WebtoolId-label': 'eVS WebTool Id',
	'usps-tier-config.eVS-WebtoolPassword-label': 'eVS WebTool Password',
	'usps-tier-config.eVS-Permit-label': 'eVS Permit',
	'usps-tier-config.eVS-Permit-Number-label': 'eVS Permit Number',
	'usps-tier-config.ePostage-WebtoolId-label': 'ePostage WebTool Id',
	'usps-tier-config.ePostage-WebtoolPassword-label': 'ePostage WebTool Password',
	'usps-tier-config.ePostage-Permit-label': 'ePostage Permit',
	'usps-tier-config.ePostage-MID-label': 'ePostage MID',
	'usps-tier-config.ePostage-Returns-MID-label': 'ePostage Returns MID',
	'usps-tier-config.ePostage-Permit-Number-label': 'ePostage Permit Number',
	'usps-tier-config.eVS-Returns-MID-label': 'eVS Returns MID',
	'usps-tier-config.eVS-MID-label': 'eVS MID',
	'usps-tier-config.eVS-Webtool-MID-label': 'eVS WebTool MID',
	'usps-tier-config.ePostage-Webtool-MID-label': 'ePostage WebTool MID',
	'usps-tier-config.consumer-key-label': 'Consumer Key',
	'usps-tier-config.consumer-secret-label': 'Consumer Secret',
	'usps-tier-config.description-label': 'Description',
	'usps-tier-config.number-of-associated-accounts-label': 'Number of Associated Accounts',
	'usps-tier-config.current-tier-label': 'Current Tier',
	'usps-tier-config.selected-tier-label': 'Selected Tier',
	'usps-tier-config.dialog-add-label': 'Add configuration',
	'usps-tier-config.dialog-edit-label': 'Edit configuration',
	'usps-tier-config.delete-config-label': 'Delete Configuration',
	'usps-tier-config.config-delete-dialog-description': 'Are you sure you want to delete this configuration?',
	'usps-tier-config.config-edit-dialog-description':
		'Update tier can impact shipment labels and manifest for CarrierAccounts in use, please make sure this is extremely necessary.',
	'usps-tier-config.tier-required-validation': 'Tier is required',
	'usps-tier-config.masterMID-required-validation': 'Master MID is required',
	'usps-tier-config.defaultRateSetId-required-validation': 'DefaultRateSetId is required',
	'usps-tier-config.tier-length-validation': 'Tier must be equals to or less than 100 characters',
	'usps-tier-config.masterMID-length-validation': 'Master MID must be equals to or less than 100 characters',
	'usps-tier-config.eVSWebtoolId-length-validation': 'eVSWebtoolId must be equals to or less than 100 characters',
	'usps-tier-config.eVSWebtoolPassword-length-validation':
		'eVSWebtoolPassword must be equals to or less than 100 characters',
	'usps-tier-config.eVSPermitNum-length-validation': 'eVSPermitNum must be equals to or less than 100 characters',
	'usps-tier-config.description-length-validation': 'Description must be equals to or less than {0} characters',
	'usps-tier-config.ePostageWebtoolId-length-validation':
		'ePostageWebtoolId must be equals to or less than 100 characters',
	'usps-tier-config.ePostageWebtoolPassword-length-validation':
		'ePostageWebtoolPassword must be equals to or less than 100 characters',
	'usps-tier-config.ePostagePermitNum-length-validation':
		'ePostagePermitNum must be equals to or less than 100 characters',
	'usps-tier-config.search-tier-placeholder': 'Search by tier name',
	'usps-tier-config-tier-fullfillment-dialog-title':
		'ePostage/PCPostage carrier accounts will be disabled for selected tier.',
	'usps-tier-config-tier-fulfillment-not-eligible-info': 'Your USPS tier is eligible for eVS accounts only.',
	'usps-tier-config-tier-fulfillment-not-eligible-info-partner': 'Tier is eligible for eVS accounts only.',
	'usps-tier-config.MID-type-validation': 'Mailer ID must only have numbers',

	// AdminAccountDetails component
	'admin-account-details.rateset-label': 'RateSet',
	'admin-account-details.current-tier-label': 'Current Tier',
	'admin-account-details.current-rate-set-label': 'Current RateSet',
	'admin-account-details.rate-set-label': 'RateSet',
	'admin-account-details.rate-description-label': 'Description',
	'admin-account-details.select-tier': 'Select a tier',
	'admin-account-details.no-tier-selected': 'No tier selected',
	'admin-account-details.no-rate-set-selected': 'Select a rate set',
	'admin-account-details.partner-label': 'Partner',
	'admin-account-details.customer-label': 'Customer',
	'admin-account-details.admin-label': 'Admin',
	'admin.account-details.add-new-tier-chip-label': 'Add New Tier',
	'admin.account-list-search-filter-label': 'Customer',
	'admin.account-list-search-filter-placeholder-label': 'Search by Company / Email / PackageHub A/C / Username',
	'admin.account-list-customer-filter-disabled-lebel': 'Not Applicable',

	// AdminAccount RateSet component
	'admin.account-customer-rateset-id-table-header': 'Id',
	'admin.account-customer-rateset-name-table-header': 'Name',
	'admin.account-customer-rateset-carrier-table-header': 'Carrier',
	'admin.account-customer-rateset-type-table-header': 'Type',
	'admin.account-customer-rateset-startDate-table-header': 'StartDate',
	'admin.account-customer-rateset-endDate-table-header': 'EndDate',
	'admin.account-customer-rateset-isInternational-table-header': 'IsInternational',
	'admin.account-customer-effectivedate-filter-label': 'Effective Date',
	'admin.account-customer-carrier-filter-label': 'Carrier',
	'admin.account-customer-effectivedate-filter-Today': 'Today',
	'admin.account-customer-effectivedate-filter-All': 'All',

	// AdminAccountUserList component
	'admin-account-user-list.acccordion-label': 'Users',
	'admin-account-user-list.update-email-dialog-description':
		'Are you sure you want to edit the user email? Please enter a valid email!',
	'admin-account-user-list.update-email-successfully': 'User email has been updated successfully',
	'admin-account-user-list.update-email-successfully': 'User email has been updated successfully',
	'admin-account-user-list.generate-temp-password-button-label': 'Generate temp password',
	'admin-account-user-list.verify-password-dialog-title': 'Admin Password Verification',
	'admin-account-user-list.generate-temp-password-dialog-description':
		'Please confirm your password to generate temporary password for user.',
	'admin-account-user-list.generate-temp-password-username-field-validation': 'UserName is required',
	'admin-account-user-list.temp-password-dialog-title': 'Generate Temporary Password',
	'admin-account-user-list.temp-password-admin-label': 'PasswordAdmin',
	'admin-account-user-list.admin-temp-password-generated-successfully': 'Temp password has been generated successfully',
	'admin-account-user-list.reset-password-button-label': 'Reset password',
	'admin-account-user-list.reset-password-dialog-description':
		'Are you sure you want to send reset password email to {0}?',
	'admin-account-user-list.temp-password-label': 'Temp password',
	'admin-account-user-list.temp-password-helper-text': 'This password is only valid till ',
	'admin-account-user-list.search-users-placeholder': 'Search by name, username or email',
	'admin.account-details.mid-assigned-label': 'USPS MID allocated to this Customer Account',
	'admin.account-details.eVS-mid-label': 'eVS MID',
	'admin.account-details.mid-returns-assigned-label': 'USPS MID (Returns) allocated to this Customer Account',
	'admin.account-details.eVS-returns-mid-label': 'eVS MID (Returns)',
	'admin.account-details.current-chip-label': 'Current',
	'admin.account-details.partner-new-tier-label': 'Tier for new customers',
	'admin.account-details.partner-new-tier-returns-label': 'Tier for new customers (Returns)',
	'admin.account-details.partner-tier-label': "Partner's Tier Config",
	'admin.account-details.partner-tier-returns-label': "Partner's Tier Config (Returns)",

	'admin.account-level-override.disable-message': 'Disabled by admin.',

	// ProductDetails component
	'product-details.current-plan-label': 'Current Plan',
	'product-details.select-plan-label': 'Select Plan',
	'product-details.subscription-details-label': 'Subscription Details',
	'product-details.call-per-day-label': 'Call allowed per day',
	'product-details.call-per-minute-label': 'Call allowed per minute',
	'product-details.active-since-label': 'Active since',
	'product-details.snackbar-update-successful': 'Subscription plan has been updated successfully',

	// Carrier PaymentType descriptions
	'carrier.PHv2.description': 'Balance adjusted by PHv2 (if applicable)',
	'carrier.Nexio.description': 'Balance adjusted by PHv3 using Nexio Gateway',
	'carrier.Postpaid.description': 'No balance adjustments, invoiced later by Carrier or Maersk Finance',
	'carrier.configuration-rating-fetch-Local': 'Rates fetched by PHv3 locally',
	'carrier.configuration-rating-fetch-Remote': 'Rates fetched by PHv2 remotely',

	// Carriers label
	'carrier.LMR-label': 'Landmark Global',
	'carrier.PB-label': 'Pitney Bowes',
	'carrier.FDEN-label': 'FedEx',
	'carrier.USPS-label': 'USPS',
	'carrier.UPS-label': 'UPS',
	'carrier.DHL-label': 'DHL',

	// AdminCustomerList component
	'admin.customer-list.subscription-plan-label': 'Subscription Plan',
	'admin.customer-list.account-type-label': 'Account Type',

	// PaymentMethodStepper component
	'payment.method.stepper-submit-button.label': 'Submit',
	'payment.method.stepper.heading': 'Add Payment Method',

	// CredentialInfoStepper component
	'credential.info.stepper.heading': 'Copy your API Key and Secret',

	// Generic messages
	'app.generic.delete-action-dialog-description': 'Are you sure you want to {0} this {1}?',
	'app.generic.deletion-failure-dialog-description': 'Would you like to disable instead?',

	// Generic button
	'app.generic.save-button-label': 'Save',
	'app.generic.cancel-button-label': 'Cancel',
	'app.generic.edit-button-label': 'Edit',
	'app.generic.delete-button-label': 'Delete',

	// QuickSignUp component
	'app.quick-sign-up.sign-up-label': 'Sign Up',
	'app.quick-sign-up.payment-info-label': 'Payment Info',
	'app.quick-sign-up.confirmation-label': 'API Keys',
	'app.quick-sign-up.success-label': 'Confirmation',
	'app.quick-sign-up.success-part1': 'Congratulations!',
	'app.quick-sign-up.success-part2': 'Your Visible account is ready for use.',
	'app.quick-sign-up.success-part3': 'You may now close this window.',

	// USPSAutoManifestScheduleComponent component
	'admin-account-auto-manifest-schedule-accordin-label': 'Auto-Manifest Schedule',
	'admin-account-auto-manifest-add-schedule-label': 'ADD SCHEDULE',
	'admin-account-auto-manifest-edit-schedule-label': 'Edit AutoManifest Schedule',
	'admin-account-auto-manifest-time-column-label': 'Time (UTC)',
	'admin-account-auto-manifest-last-executed-date-column-label': 'Last Execution Status',
	'admin-account-auto-manifest-download-scan-form-column-label': 'Download SCAN form(s)',
	'admin-account-auto-manifest-status-column-label': 'Status',
	'admin-account-auto-manifest-status-Enabled-label': 'Enabled',
	'admin-account-auto-manifest-status-Disabled-label': 'Disabled',
	'admin-account-auto-manifest-automanifest-delete-dialog-label': 'Delete AutoManifest Schedule',
	'admin-account-auto-manifest-automanifest-delete-dialog-description':
		'Are you sure you want to delete this schedule?',
	'admin-account-auto-manifest-automanifest-change-status-dialog-label': 'Change AutoManifest Status',
	'admin-account-auto-manifest-automanifest-change-status-dialog-description-label':
		' Are you sure you want to change the status of this schedule?',
	'admin-account-auto-manifest-description-column-label': 'Description',
	'admin-account-auto-manifest-same-time-error-label':
		'You already have a schedule at this time. Please select a different time.',
	'admin-account-auto-manifest-schema-validation-error-message': 'Time is required, please select a time.',
};



// WEBPACK FOOTER //
// ./src/translations/messages-en.js